import { COLORS } from '../utils/colors';
import { siteContent } from '../content';
import { RockmelonLogo } from './Logo';

export const ComingSoon = () => (
  <div
    className="min-h-screen flex flex-col items-center justify-center px-6"
    style={{
      background: 'linear-gradient(135deg, #FFF7F0 0%, #F0FDFA 50%, #F8FAFC 100%)',
      fontFamily: 'Inter, sans-serif',
    }}
  >
    <RockmelonLogo size={120} />
    <h1
      className="mt-8 text-4xl sm:text-5xl font-bold tracking-tight text-center"
      style={{ color: COLORS.navy }}
    >
      {siteContent.company.name}
      <span style={{ color: COLORS.cantaloupe }}>.io</span>
    </h1>
    <p
      className="mt-4 text-lg sm:text-xl text-center"
      style={{ color: COLORS.slate }}
    >
      {siteContent.company.tagline}
    </p>
    <span
      className="mt-10 px-6 py-2 rounded-full text-sm font-medium tracking-wide"
      style={{
        color: COLORS.cantaloupe,
        border: `1px solid ${COLORS.cantaloupe}`,
      }}
    >
      Coming Soon
    </span>
  </div>
);
